var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-card',{staticClass:"contracts-card"},_vm._l((_vm.getContractors),function(contractor){return _c('contract-list',{key:contractor.id,attrs:{"contractor":contractor}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }